import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fce99812&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce99812')) {
      api.createRecord('fce99812', component.options)
    } else {
      api.reload('fce99812', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fce99812&", function () {
      api.rerender('fce99812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Preview/Post/LikersCount/index.vue"
export default component.exports